export function stringify(begin: string | undefined, end: string | undefined) {
  return `${begin || ""}-${end || ""}`;
}
